module.exports = "<div class=\"ui container center aligned top-marged\" #container>\n  <div class=\"ui grid\">\n    <div class=\"eight wide column left aligned\"><h1 class=\"ui large header\">Généalogie</h1></div>\n    <div class=\"eight wide column right aligned\"><button class=\"ui button\" (click)=\"showUserTree()\">Réinitialiser la vue</button></div>\n  </div>\n\n  <div id=\"graph\" #graph></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/trees/trees.component.html
// module id = 1026
// module chunks = 0